import React, {useMemo} from 'react';

import {NoteDay} from 'notebook/util/NoteUtilConstants';
import useHashNavigation from 'ui-library/hooks/useHashNavigation';

import {useProvenanceUuidToCidMap} from '../util/DayNavigationUtil';

// Component that handles hash navigation independently of note content changes
export const HashNavigationManager = React.memo(
  ({noteDays, documentContainer}: {noteDays: Array<NoteDay>; documentContainer?: HTMLElement | null}) => {
    // Use memoized map for better performance with large notebooks
    // Note that if multiple instances of the same provananceUuid are present in the noteDays array,
    // the last one wins.
    const provenanceUuidToCidMap = useProvenanceUuidToCidMap(noteDays);

    // Memoize the valueFn to prevent unnecessary re-renders
    const memoizedValueFn = useMemo(
      () => (anchorValue: string) => provenanceUuidToCidMap.get(anchorValue),
      [provenanceUuidToCidMap]
    );

    useHashNavigation({
      container: documentContainer,
      anchorConfig: {
        hashParam: 'anchor',
        elementAttr: 'data-scroll-id',
        valueFn: memoizedValueFn,
      },
    });

    return null; // This component doesn't render anything
  },
  (prevProps, nextProps) =>
    // Only re-render if noteDays array actually changed or documentContainer changed
    prevProps.noteDays === nextProps.noteDays && prevProps.documentContainer === nextProps.documentContainer
);
